import Quill from "quill";
import { stickers_sets } from "@/components/chat/utils/stickers-config";
import { cache } from "@/components/chat/utils/ddemoji";
const EmbedBlot = Quill.import("blots/embed");
export default class Emoji extends EmbedBlot {
  static blotName = "custom-emoji";
  static className = "e-emoji";
  static tagName = "IMG";
  static create(value: any) {
    // console.log('value', value);
    const node = super.create(value) as any;
    let map = new Map();
    // 为了兼容移动端这两个表情显示错误做了如下处理，移动端这个表情的长度为2，桌面端为1，所以当匹配到这个表情时，替换为新的
    map.set("✌️", "[胜利]");
    map.set("☕️", "[咖啡]");
    node.innerText = "";
    node.setAttribute("data-value", value);
    if (map.get(value) && !cache[`./${stickers_sets[value]}`]) {
      node.setAttribute("src", cache[`./${stickers_sets[map.get(value)]}`]);
    } else {
      node.setAttribute("src", cache[`./${stickers_sets[value]}`]);
    }
    node.classList.add("input-emoji");
    return node;
  }
  static value(domNode: HTMLLinkElement) {
    const { value } = domNode.dataset;
    return value;
  }
}
